import classNames from 'classnames';
import * as React from 'react';
import { useRef } from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { useExperimentAwareUrl } from '../../Experimentation/Components/ResolveExperimentId';
import { renderInfoLabel } from '../../ReactComponents/InfoLabel/InfoLabel';
import { ResponsivePicture } from '../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { withPromotionImpression } from '../../Tracking/GoogleTagManager/PromotionImpression/WithPromotionImpression';
import { hasLineBreak } from '../TextUtils';
import { BannerBackgroundVariant } from './BannerBackgroundVariant.csharp';
import { LinkDisplayType } from './LinkDisplayType.csharp';
import { MainBannerProps } from './MainBannerProps.csharp';

const MainBanner: React.FC<MainBannerProps> = ({ model, profile, discountVariant, isLazyLoaded }) => {
    const linkDisplayModifier =
        model.linkDisplayType == LinkDisplayType.Button ? 'Button Button--Quaternary Button--XSmall MainBanner__Button' : 'MainBanner__Link';
    const colorModifier = `MainBanner--${BannerBackgroundVariant[model.backgroundVariant]}`;

    const contentRef = useRef(null);

    const link = useExperimentAwareUrl(model.link, contentRef);

    return (
        <a ref={contentRef} href={link} className={classNames('MainBanner', colorModifier)} target={model.openInNewTab ? '_blank' : '_self'} rel="noreferrer">
            <div className="MainBanner__Content">
                <div className="MainBanner__Picture">
                    <ResponsivePicture profile={profile} model={model.image} isLazyLoaded={isLazyLoaded} />
                </div>

                {model.discount && <div className="MainBanner__DiscountLabel">{renderInfoLabel(model.discount, discountVariant)}</div>}

                <div className="MainBanner__Body">
                    <h2 className={classNames('MainBanner__Heading', hasLineBreak(model.heading) && 'MainBanner__Heading--LineBreak')}>{model.heading}</h2>

                    {model.description && <p className="MainBanner__Description">{model.description}</p>}

                    {model.link && (
                        <span className={linkDisplayModifier}>
                            <span>{getTranslation(keys['mainBanner.readMore'])}</span>
                        </span>
                    )}
                </div>
            </div>
        </a>
    );
};

export default withPromotionImpression(MainBanner);
